import { ActionTree } from 'vuex';
import { IState } from './state';
import { IStore } from '../index';

export default {
} as ActionTree<IState, IStore>
